// extracted by mini-css-extract-plugin
module.exports = {"root":"vUDE3OeUtU7AhBB4rrbb","contents":"Oxr5Qur8vEwyUnwWwbDI"};